import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
import type { AccountInfo } from '@azure/msal-browser';

const useActiveAccount = (): AccountInfo | undefined => {
  const { instance, accounts } = useMsal();

  return useMemo(() => {
    const active = instance.getActiveAccount?.();
    return active ?? accounts[0];
  }, [accounts, instance]);
};

export default useActiveAccount;
